
import React from "react";
import { Link } from "react-router-dom";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';


const DELIVERY_DAYS_MIN = 3;
const DELIVERY_DAYS_MAX = 7;

// Produktet e location 2636 kanë periudhë arritjeje më të gjatë
const EXTENDED_DELIVERY_LOCATION = "2636";
const EXTENDED_DELIVERY_DAYS_MIN = 7;
const EXTENDED_DELIVERY_DAYS_MAX = 14;

function formatDeliveryDate(daysFromToday) {
    const date = new Date();
    date.setDate(date.getDate() + daysFromToday);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
}

function getDeliveryDateRange(location) {
    const isExtended = String(location ?? "").trim() === EXTENDED_DELIVERY_LOCATION;
    return {
        from: formatDeliveryDate(isExtended ? EXTENDED_DELIVERY_DAYS_MIN : DELIVERY_DAYS_MIN),
        to: formatDeliveryDate(isExtended ? EXTENDED_DELIVERY_DAYS_MAX : DELIVERY_DAYS_MAX),
    };
}

function InfoIcon({ className = "w-4 h-4" }) {
    return (
        <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden>
            <circle cx="12" cy="12" r="10" stroke="#fca700" strokeWidth="2" />
            <path d="M12 8.5v.01" stroke="#fca700" strokeWidth="2" strokeLinecap="round" />
            <path d="M11.5 11.5h1v4h-1z" stroke="#fca700" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

export default function Summary({ prodDetails = {} }) {
    const deliveryDateRange = getDeliveryDateRange(prodDetails?.location);
    const country =
        prodDetails?.attributes?.["Country of origin"] ||
        prodDetails?.attributes?.CountryOfOrigin ||
        "Not available";
    const composition = prodDetails?.attributes?.Composition || "Not available";

    return (
        <div className="space-y-6">
            <div className="qty_sec_wrapper">
                <h2>Përshkrimi</h2>
            </div>

            <p className="text-sm text-gray-700 mb-1">
                {prodDetails?.description ? prodDetails.description : ""}
            </p>

            <div className="accordian-product-details space-y-4">

                <section className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                    <header className="flex items-center px-4 py-3 border-b border-gray-100">
                        <div className="flex items-center space-x-3">
                            <div className="w-2.5 h-2.5 bg-[#000000] rounded-sm" />
                            <h3 className="text-sm font-semibold text-[#000000]">Detajet</h3>
                        </div>
                    </header>

                    <div className="px-4 py-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div>
                                <div className="text-xs text-gray-400">Kodi</div>
                                <div className="text-sm font-medium text-gray-800">{prodDetails?.externalId ?? "—"}</div>
                            </div>

                            <div>
                                <div className="text-xs text-gray-400">Origjina</div>
                                <div className="text-sm font-medium text-gray-800">{country}</div>
                            </div>

                            <div>
                                <div className="text-xs text-gray-400">Composition</div>
                                <div className="text-sm font-medium text-gray-800">{composition}</div>
                            </div>

                            {prodDetails?.dimensions && prodDetails.dimensions.length > 0 && (
                                <div className="sm:col-span-2 lg:col-span-1">
                                    <div className="text-xs text-gray-400">Përmbajtja</div>
                                    <div className="text-sm font-medium text-gray-800">{prodDetails.dimensions}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>

                {/* Transporti & Kthimet */}
                <section className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                    <header className="flex items-center px-4 py-3 border-b border-gray-100">
                        <div className="flex items-center space-x-3">
                            <div className="w-2.5 h-2.5 bg-[#000000] rounded-sm" />
                            <h3 className="text-sm font-semibold text-[#000000]">Transporti & Kthimet</h3>
                        </div>
                    </header>

                    <div className="px-4 py-4">
                        <div className="space-y-4">
                            <div className="flex items-start space-x-3">
                                <div className="flex-none w-10 h-10 rounded-md bg-gray-50 border flex items-center justify-center">
                                    <svg width="18.5" height="15.031" viewBox="0 0 18.5 15.031">
                                        <path
                                            id="Icon_metro-truck"
                                            data-name="Icon metro-truck"
                                            d="M21.07,13.878,18.758,9.253H15.289V6.94a1.16,1.16,0,0,0-1.156-1.156H3.727A1.16,1.16,0,0,0,2.571,6.94v9.25l1.156,1.156H5.193a2.312,2.312,0,1,0,4,0h6.4a2.312,2.312,0,1,0,4,0H21.07V13.878Zm-5.781,0V10.409h2.4l1.734,3.469H15.289Z"
                                            transform="translate(-2.571 -5.784)"
                                        />
                                    </svg>
                                </div>

                                <div className="flex-1">
                                    <div className="flex items-center space-x-2">
                                        <div className="text-sm font-medium text-gray-700">
                                            Koha e dërgesës: {deliveryDateRange.from} – {deliveryDateRange.to}
                                        </div>


                                        <Tippy interactive={true} interactiveBorder={20} delay={100} content={<span>
                                            Ju do të pranoni dërgesën ndërmjet {deliveryDateRange.from} dhe {deliveryDateRange.to}. Tarifa e transportit është 3€ për çdo porosi. Për më shumë detaje, lexoni
                                            <Link to={"/returns"} className="text-white pl-2" style={{ textDecoration: 'underline white' }}>kushtet e transportit</Link>
                                        </span>}
                                        >
                                            <svg width={22} height={22} viewBox="0 0 22 22">
                                                <g
                                                    id="Icon_feather-info"
                                                    data-name="Icon feather-info"
                                                    transform="translate(-2 -2)"
                                                >
                                                    <path
                                                        id="Path_604"
                                                        data-name="Path 604"
                                                        d="M23,13A10,10,0,1,1,13,3,10,10,0,0,1,23,13Z"
                                                        fill="none"
                                                        stroke="#000000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                    <path
                                                        id="Path_605"
                                                        data-name="Path 605"
                                                        d="M18,22V18"
                                                        transform="translate(-5 -5)"
                                                        fill="none"
                                                        stroke="#000000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                    <path
                                                        id="Path_606"
                                                        data-name="Path 606"
                                                        d="M18,12h0"
                                                        transform="translate(-5 -3)"
                                                        fill="none"
                                                        stroke="#000000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                </g>
                                            </svg>
                                        </Tippy>




                                    </div>

                                    <p className="text-sm text-gray-500 mt-1">Dërgesë standarde brenda vendit.</p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-3">
                                <div className="flex-none w-10 h-10 rounded-md bg-gray-50 border flex items-center justify-center">
                                    {/* return icon */}
                                    <svg
                                        enableBackground="new 0 0 24 24"
                                        height={512}
                                        viewBox="0 0 24 24"
                                        width={512}
                                        style={{ width: 19, height: 16 }}
                                    >
                                        <path d="m17.743 14.87 1.781-1.555c.312-.272.345-.746.072-1.058-.272-.312-.746-.344-1.059-.072l-3.281 2.864c-.162.142-.256.348-.256.565s.094.423.257.565l3.281 2.863c.143.124.318.185.493.185.209 0 .417-.087.565-.257.272-.312.24-.786-.072-1.058l-1.758-1.534c2.622.079 4.733 2.268 4.733 4.962v1.909c0 .414.336.75.75.75s.751-.335.751-.749v-1.909c0-3.531-2.796-6.406-6.257-6.471z" />
                                        <path d="m9.22 0-4.86.02c-.63 0-1.22.35-1.52.9l-2.54 4.6 8.43-.02z" />
                                        <path d="m19.68 5.48-2.57-4.6c-.31-.55-.89-.9-1.53-.9l-4.86.02.51 5.5z" />
                                        <path d="m20 10.18c-.3-.12-.63-.18-.97-.18-.66 0-1.3.24-1.81.68l-3.28 2.86c-.6.52-.94 1.28-.94 2.07 0 .8.34 1.55.94 2.08l2.64 2.3-14.97.04c-.01 0-.01 0-.01 0-.86 0-1.57-.71-1.57-1.58l-.04-11.43 9.25-.02h1.5l9.25-.03z" />
                                    </svg>
                                </div>

                                <div className="flex-1">
                                    <div className="flex items-center space-x-2">
                                        <div className="text-sm font-medium text-gray-700">Politikat e kthimit</div>

                                        <Tippy interactive={true} interactiveBorder={20} delay={100} content={<span>Ju keni të drejtë të ktheni porosinë tuaj brenda afatit prej 14 ditësh nga data e pranimit. Rimbursimi i mjeteve bëhet në llogarinë tuaj bankare. Për më shumë, lexoni ‘Politikat e kthimit’</span>}>

                                            <svg width={22} height={22} viewBox="0 0 22 22">
                                                <g
                                                    id="Icon_feather-info"
                                                    data-name="Icon feather-info"
                                                    transform="translate(-2 -2)"
                                                >
                                                    <path
                                                        id="Path_604"
                                                        data-name="Path 604"
                                                        d="M23,13A10,10,0,1,1,13,3,10,10,0,0,1,23,13Z"
                                                        fill="none"
                                                        stroke="#000000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                    <path
                                                        id="Path_605"
                                                        data-name="Path 605"
                                                        d="M18,22V18"
                                                        transform="translate(-5 -5)"
                                                        fill="none"
                                                        stroke="#000000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                    <path
                                                        id="Path_606"
                                                        data-name="Path 606"
                                                        d="M18,12h0"
                                                        transform="translate(-5 -3)"
                                                        fill="none"
                                                        stroke="#000000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                </g>
                                            </svg>

                                        </Tippy>

                                    </div>

                                    <p className="text-sm text-gray-500 mt-1">Kthim i lehtë brenda 14 ditësh.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
